import React, { useEffect, useState } from "react";
import SimpleGraph from "./simple_graph.js";
import "./statistics.css";
import DownloadCSVButton from "../Unique/Misc/download_csv_button";
import { useStatisticsContext } from "./statistics_context";
import Tooltip from "@mui/material/Tooltip";
import { get } from "../../lib/api";

const FourGraph = ({ game_id }) => {
  // const [statistics, setStatistics] = useState({});
  const [retention, setRetention] = useState({});
  const [loading, setLoading] = useState(false);
  const { generalStatistics, generalStatsLoading } = useStatisticsContext();
  // const [exportData, setExportData] = useState([]);

  // Initialize retention date to 11 days ago as the default
  const getDefaultDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 11);
    return date.toISOString().split("T")[0];
  };

  const [retentionDate, setRetentionDate] = useState(getDefaultDate());

  useEffect(() => {
    if (!game_id) return;

    const fetchRetentionRateData = async () => {
      setLoading(true);
      const data = await get(`/statistics?method=getRetentionRate&date=${retentionDate}&gameid=${game_id}`);
      setRetention(data);
      setLoading(false);
    };

    fetchRetentionRateData();
  }, []);

  const handleDateChange = (event) => {
    setLoading(true);
    if (!game_id) return;
    const newDate = event.target.value;
    setRetentionDate(newDate); // Update state for future re-renders

    const fetchRetentionRateData = async () => {
      const data = await get(`/statistics?method=getRetentionRate&date=${newDate}&gameid=${game_id}`);
      setRetention(data);
      setLoading(false);
    };

    fetchRetentionRateData();
  };

  useEffect(() => {
    // console.log("retention: ");
    // console.log(retention);
  }, [retention]);

  if (generalStatsLoading || loading) {
    return <div>Loading...</div>; // Show loading until all data is ready
  }

  const formattedExportData = {
    date: generalStatistics ? generalStatistics["date"] || "Loading date..." : "Loading date...",
    "Total Gameplays": generalStatistics ? generalStatistics["Total Launches"] || "Loading total gameplays..." : "Loading total gameplays...",
    "Total Users": generalStatistics ? generalStatistics["Total Unique Users who played the daily challenge"] || "Loading total users..." : "Loading total users...",
    "Total Advertisements": generalStatistics ? generalStatistics["Total Ads"] || "Loading total advertisements..." : "Loading total advertisements...",
    "Retention Rate":
      retention && retention["day1_retention_percentage"] && retention["day1_retention_percentage"][0] !== undefined
        ? [100, retention["day1_retention_percentage"][0], retention["day7_retention_percentage"][0], retention["day10_retention_percentage"][0]]
        : ["Loading retention rates..."],
  };

  return (
    <div>
      <div className="four-graph-container">
        <>
          <div className="small-graph-container">
            <h3>Total Gameplays</h3>
            {generalStatistics && generalStatistics["Total Gameplays"] ? (
              <SimpleGraph key={Date.now()} x={generalStatistics["date"]} y={generalStatistics["Total Gameplays"]} type={"scatter"} />
            ) : (
              <p>Loading total gameplays...</p>
            )}
          </div>
          <div className="small-graph-container">
            <Tooltip title="Total Unique Users who entered the game.">
              <h3>Total Users</h3>
            </Tooltip>
            {generalStatistics && generalStatistics["Total Unique Users who entered the game"] ? (
              <SimpleGraph key={Date.now()} x={generalStatistics["date"]} y={generalStatistics["Total Unique Users who entered the game"]} type={"scatter"} />
            ) : (
              <p>Loading total users...</p>
            )}
          </div>
          <div className="small-graph-container">
            <h3>Total Advertisements</h3>
            {generalStatistics && generalStatistics["Total Ads"] ? (
              <SimpleGraph key={Date.now()} x={generalStatistics["date"]} y={generalStatistics["Total Ads"]} type={"scatter"} />
            ) : (
              <p>Loading total advertisements...</p>
            )}
          </div>
          <div className="small-graph-container">
            <h3>10 Day Retention</h3>
            {retention && retention["day1_retention_percentage"] && retention["day1_retention_percentage"][0] !== undefined ? (
              <SimpleGraph
                key={Date.now()}
                x={["Day 0", "Day 1", "Day 7", "Day 10"]}
                y={[100, retention["day1_retention_percentage"][0], retention["day7_retention_percentage"][0], retention["day10_retention_percentage"][0]]}
                type={"bar"}
              />
            ) : (
              <p>Loading retention rates...</p>
            )}
          </div>
        </>
      </div>
      <div className="button-stretch">
        <div className="Retention-date">
          <label className="date-label">Retention date:</label>
          <input className="date" type="date" value={retentionDate} onChange={handleDateChange} max={getDefaultDate()} />
        </div>
        <DownloadCSVButton data={formattedExportData} fileName={"Users Stats for Game ID " + game_id} />
      </div>
    </div>
  );
};

export default FourGraph;
